<pbc-filter-preset
  [filter]="objekte.preset$ | async"
  [filters]="objekte.presets$ | async"
  [name]="objekte.search$ | async"
  (select)="objekte.setFilter($event)"
  (save)="objekte.writeFilter($event)"
  (delete)="objekte.deleteFilter($event)"
></pbc-filter-preset>
